import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-five',
  templateUrl: './welcome-five.component.html',
  styleUrls: ['./welcome-five.component.css']
})
export class WelcomeFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
